'use client'

export default function AvaIconOrb({ size = 140, pulse = false }) {
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      {pulse && [0, 1, 2].map(i => (
        <div key={i} style={{
          position: 'absolute',
          inset: -size * 0.08 * (i + 1),
          borderRadius: '50%',
          border: `1.5px solid rgba(50,105,248,${0.35 - i * 0.1})`,
          animation: `avaRing${i} ${2.2 + i * 0.3}s ease-out infinite`,
        }} />
      ))}

      <div style={{
        position: 'absolute',
        inset: -size * 0.2,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(50,105,248,0.45), transparent 60%)',
        filter: 'blur(16px)',
      }} />

      <div style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(50,105,248,0.45), inset 0 2px 8px rgba(255,255,255,0.2)',
        animation: pulse ? 'avaBreathe 2.6s ease-in-out infinite' : 'none',
      }}>
        <img
          src="/landing-v2/ava-icon.png"
          alt="AVA"
          style={{ width: '100%', height: '100%', display: 'block' }}
        />
      </div>
    </div>
  )
}
